import React,{Component} from 'react';
import { ref , storage } from '../config/constants'



class JobOrder extends Component{
    constructor(){
        super();
        
        this.handleSubmitJobOrder = this.handleSubmitJobOrder.bind(this);
            
        }

    

    handleSubmitJobOrder(e){
        e.preventDefault();

        let file = this.excelFile.files[0];
        if(file){
        let storageRef = storage.child("JobOrder/"+ file.name);
        let upload = storageRef.put(file);

            upload.on('state_changed', function progress(){

            },function error(err){
                alert("Something went wrong "+err.code)
            },function complete(){
                
                let jobOrder = {
                    quoteNumber: this.props.quoteNumber,
                    user : this.props.userId, 
                    jobFile : file.name
                    
                } 
                ref.child("JobOrder").push(jobOrder).then(()=>{
                 alert("Files Uploaded successfully")
                });    
            }.bind(this))
        }else{
            alert("You must select a file ")
        }
        
        this.jobOrderForm.reset()
    }

    
    
    render() {
            
        return (
            <form className="form-horizontal form-bordered" ref = {input => this.jobOrderForm = input } onSubmit={this.handleSubmitJobOrder} >
                <div className="form-group">
                    <label className="col-md-3 control-label" htmlFor="example-file-input">File input</label>
                    <div className="col-md-9">
                        <input type="file" id="example-file-input"  ref={(input) => {this.excelFile =input}} />
                    </div>
                </div>

                <div className="submitContract text-center">
                   <button type="submit" className="btn btn-primary"><i className="fa fa-floppy-o"></i> Save</button>
                </div>
            </form>                       
                
        );
    }
}

export default  JobOrder;



// WEBPACK FOOTER //
// ./src/components/JobOrder.js